<template>
  <div>
    <card class="h-full">
        <template v-slot:header>Buchungen in der Woche</template>
        <chart-bar :data="bookings" :labels="labels" :headline="'Buchungen'"> </chart-bar>
        <capacity></capacity>
        
    </card>

  </div>
</template>

<script>

import Card from "./UI/Card";
import ButtonSecondary from "./UI/ButtonSecondary";
import ChartBar from "./Chart/ChartBar";
import Capacity from "./Capacity"

export default {
    name: "WeeklySchedule",
    components: {ButtonSecondary, Card, ChartBar, Capacity},
    inject: ['group'],

    data: () => ({
        bookings: [],
        labels: [],
        date: new Date(),
    }),

    mounted() {
        this.load(this.date);
    },

    methods: {
        load(date) {
            window.axios.get('/admin/weekly_stats', {
                params: {
                    date: date,
                    periodicity: 'weeks',

                }
            }).then(result => {
                this.labels = result.data.oldData.map(g => g.day);
                this.bookings = result.data.oldData.map(g => g.bookings);
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        },
    }
    
}
</script>

<style>

</style>